const AdminDocuments = () =>
  import(
    /* webpackChunkName: "AdminDocuments" */ "@/components/certipers-admin/profile/AdminDocuments.vue"
  );
const UserProfile = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/shared/UserProfile.vue");

export default [
  {
    path: "adminProfile",
    name: "admin-profile-main",
    component: UserProfile,
  },
  {
    path: "documents",
    name: "admin-documents",
    component: AdminDocuments,
  },
];
